
import React from 'react';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/Dashboard/TopBar';
import Overview from '../components/Dashboard/Overview';
import Rooms from '../components/Dashboard/Rooms';
import RoomAndFloorStatus from '../components/Dashboard/RoomAndFloorStatus';
import OccupancyAndFeedback from '../components/Dashboard/OccupancyAndFeedback';

const Layout = ({ children }) => {
  return (
    <>
    <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        html, body {
          height: 100%;
          font-family: 'Open Sans', sans-serif;
        }
      
      `}</style>
      
      <div style={{ display: 'flex', height: '100vh' }}>
      <Sidebar />
      <main style={{ flex: 1, padding: '0px', overflowY: 'auto' }}>
      <TopBar />
      <Overview />
      <Rooms />
      <RoomAndFloorStatus />
      <OccupancyAndFeedback />
      
      </main>
    </div>
      </>
    
  );
};

export default Layout;
